export function formatTimeAgo(timestamp: number, now: number) {
    const secondsPast = Math.floor((now - timestamp) / 1000)
    if (secondsPast < 1) {
        return "just now"
    }
    if (secondsPast < 60) {
        return `${secondsPast} sec ago`
    }
    const minutesPast = Math.floor(secondsPast / 60)
    if (minutesPast < 60) {
        return `${minutesPast} min ago`
    }
    const hoursPast = Math.floor(minutesPast / 60)
    if (hoursPast < 24) {
        return `${hoursPast} hr ago`
    }
    return new Date(timestamp).toLocaleDateString()
}
